import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/menu/initialStates/ingredients_initialState.ts
var INGREDIENT_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  ingredientId: 0,
  active: true,
  name: "",
  posName: "",
  itemIds: [],
  itemMenuTypeIds: {},
  is86ed: false
});

export { INGREDIENT_INITIAL_STATE };
